export default __webpack_public_path__ + "static/media/help-circle.33502c27.svg";